<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Afvalproducten</h1>
      </div>

      <div class="dropdown">
        <button
          class="btn btn-dark"
          type="button"
          id="dropdownMenuButton"
          v-on:click="modalToevoegenAfvalproduct()"
        >
          <i class="fas fa-plus"></i> Afvalproduct toevoegen
        </button>
      </div>
    </div>

    <br />
    <br />

    <vue-good-table
      v-if="afvalproducten && afvalproducten.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="afvalproductColumns"
      :rows="afvalproducten"
      :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 100,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
      :selectOptions="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="afvalproductModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  class="nav-link active show"
                  href="#algemeenTab"
                  aria-controls="algemeenTab"
                  role="tab"
                  data-toggle="tab"
                >Algemeen</a>
              </li>
              <li role="presentation">
                <a
                  class="nav-link"
                  href="#prijzenTab"
                  aria-controls="prijzenTab"
                  role="tab"
                  data-toggle="tab"
                >Prijzen</a>
              </li>
            </ul>

            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="algemeenTab">
                <div v-if="afvalproduct">
                  <label>Naam</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="afvalproduct.naam"
                    placeholder="Naam"
                  />
                  <label>Beschrijving</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="afvalproduct.beschrijving"
                    placeholder="Beschrijving"
                  />
                  <label>R-code</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="afvalproduct.R"
                    placeholder="R-code"
                  />
                  <label>EURAL</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="afvalproduct.EURAL"
                    placeholder="EURAL"
                  />
                </div>
              </div>
              <div role="tabpanel" class="tab-pane" id="prijzenTab">
                <label>Prijs per ton (€)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="afvalproduct.prijs"
                  placeholder="Prijs per ton"
                />
                <hr />
                <ul id="prijslijst">
                  <li>
                    <span>Container (m²)</span>
                    <span>Max. inhoud (kg)</span>
                    <span>Prijs (€)</span>
                  </li>
                  <li v-for="prijs in prijzen" :key="prijs.id">
                    <input class="form-control" type="text" v-model="prijs.grootte_container" />
                    <input class="form-control" type="text" v-model="prijs.max_inhoud" />
                    <input class="form-control" type="text" v-model="prijs.prijs" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewAfvalproduct === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteAfvalproduct()"
            >Verwijderen</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Sluiten</button>
            <button
              v-if="checkNewAfvalproduct"
              type="button"
              class="btn btn-primary"
              v-on:click="createAfvalproduct()"
            >Opslaan</button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              v-on:click="updateAfvalproduct()"
            >Aanpassen</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";

export default {
  name: "app",
  components: {},
  data() {
    return {
      checkNewAfvalproduct: false,
      importType: "-1",
      importCategory: "-1",
      types: [
        {
          name: "Afvalproducten",
        },
        {
          name: "Afvalproducten",
        },
        {
          name: "Leveradressen",
        },
      ],
      editModalTitle: "",
      afvalproduct: {},
      klanten: {},
      prijzen: {},
      afvalproducten: {
        attributes: [],
        related: [],
      },
      afvalproductColumns: [
        { label: "Naam", field: "naam", filterOptions: { enabled: true } },
        {
          label: "R-code",
          field: "R",
          filterOptions: { enabled: true },
        },
        { label: "EURAL", field: "EURAL", filterOptions: { enabled: true } },
      ],
      attrPos: 0,
    };
  },
  mounted() {
    this.getAfvalproducten();
  },
  methods: {
    getAfvalproducten() {
      axios
        .get("https://hofman.weblion.be/api/afvalproducten/")
        .then((response) => {
          this.afvalproducten = response.data;
          console.log(this.afvalproducten);
        });
    },
    deleteAfvalproduct() {
      axios
        .delete("https://hofman.weblion.be/api/afvalproducten/", {
          data: {
            afvalproduct_id: this.afvalproduct.id,
          },
        })
        .then((response) => {
          this.getAfvalproducten();
          $("#afvalproductModal").modal("hide");
          console.log(response.data);
        });
    },
    updateAfvalproduct() {
      axios
        .put("https://hofman.weblion.be/api/afvalproducten/", {
          afvalproduct: this.afvalproduct,
        })
        .then(() => {
          axios
            .put("https://hofman.weblion.be/api/prijzen/", {
              prijzen: this.prijzen,
            })
            .then((response) => {
              this.getAfvalproducten();
              $("#afvalproductModal").modal("hide");
              console.log(response.data);
            })
            .catch(function (error) {
              console.log(error);
            });
        });
    },
    createAfvalproduct() {
      axios
        .post("https://hofman.weblion.be/api/afvalproducten/", {
          afvalproduct: this.afvalproduct,
        })
        .then((response) => {
          this.getAfvalproducten();
          $("#afvalproductModal").modal("hide");
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    modalToevoegenAfvalproduct() {
      this.afvalproduct = {};
      this.editModalTitle = "Afvalproduct toevoegen";

      this.checkNewAfvalproduct = true;

      $("#afvalproductModal").modal("show");
    },
    getPrijzen(afvalproduct) {
      axios
        .get("https://hofman.weblion.be/api/prijzen/", {
          params: {
            afvalproduct: afvalproduct,
          },
        })
        .then((res) => {
          this.prijzen = res.data;
          console.log(this.prijzen);
        });
    },
    onRowClick(table) {
      this.editModalTitle = "Afvalproduct aanpassen";
      this.afvalproduct = table.row;

      this.checkNewAfvalproduct = false;

      this.getPrijzen(this.afvalproduct.id);

      $("#afvalproductModal").modal("show");
    },
    selectionChanged(table) {
      this.afvalproductenSelected = table.selectedRows;
    },
    modalAanpassenAfvalproduct() {
      this.checkNewAfvalproduct = false;
      this.editModalTitle = "Afvalproduct aanpassen";

      $("#afvalproductModal").modal("show");
    },
    sAfvalproduct() {
      axios
        .post("https://hofman.weblion.be/api/afvalproducten/update.php", {
          afvalproduct: this.afvalproduct,
        })
        .then((res) => {
          console.log(res);
          this.getAfvalproducten();
        })
        .then(function () {
          $("#afvalproductModal").modal("hide");
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#afvalproductModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}
.btn-danger {
  margin-right: 210px;
}
#prijslijst {
  list-style-type: none;
  padding: 0;
}
#prijslijst li input,
#prijslijst li span {
  display: inline-block;
  width: 32%;
}
#prijslijst li span {
  margin-bottom: 5px;
}
#prijslijst li input,
#prijslijst li span {
  margin-right: 2%;
}
#prijslijst li input:last-child,
#prijslijst li span:last-child {
  margin-right: 0%;
}
</style>
